/* eslint-disable vue/no-v-html */
<template>
  <div class="">
    <div class="bg-white text-xs relative" @mouseleave="hideTooltip">
      <div class="flex items-center h-6 mb-px">
        <div class="w-40 sm:w-80 px-2 py-1 flex items-center space-x-2">
          <div class="w-44 flex-grow text-left truncate">
            <div
              class="flex items-center whitespace-nowrap font-medium hover:text-gray-900 hover:font-bold"
            ></div>
          </div>
        </div>
        <div class="heat-map-row ml-2 font-sans">
          <div
            v-for="(cat, i) in categories"
            :key="i"
            class="heat-map-head-square"
            :class="{ rotate: rotateHeaders }"
          >
            <div class="">{{ cat }}</div>
          </div>
        </div>
      </div>

      <transition-group name="flip-list" tag="div" class="" appear>
        <div
          v-for="row in data"
          :key="row.name"
          class="flex items-center hover:bg-gray-100 h-6 mb-px"
        >
          <div class="w-40 sm:w-80 px-2 py-1 flex items-center space-x-2">
            <div class="w-44 flex-grow text-left truncate">
              <div
                class="flex items-center whitespace-nowrap font-medium hover:text-gray-900 hover:font-bold"
              >
                <span class="truncate">{{ row.name }}</span>
              </div>
            </div>
          </div>
          <div class="heat-map-row ml-2">
            <div
              v-for="(col, i) in row.values"
              :key="i"
              class="heat-map-square"
              :style="{
                'background-color': color(col),
                width: `${(100 * 100) / 60}%`,
              }"
              @mouseenter="showTooltip($event, row, i)"
            >
              <!-- <span class="">&nbsp;</span> -->
            </div>
          </div>
        </div>
      </transition-group>
      <VTooltip :show="tooltip.show" :target="tooltip.target" class="z-30">
        <div
          class="bg-black bg-opacity-80 text-white px-4 py-2 rounded-lg text-xs flex items-center"
        >
          <div class="">
            <div class="font-bold">{{ tooltip.title }}</div>
            <div>{{ tooltip.value }}%</div>
          </div>
        </div>
      </VTooltip>
    </div>
  </div>
</template>

<script>
import { scaleLinear, interpolateRgb, extent, max } from "d3";
import colors from "@/utils/colors";
// import CountryFlag from "@/components/CountryFlag";
import VTooltip from "@/components/VTooltip";

export default {
  components: {
    // CountryFlag,
    VTooltip,
  },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    colorRange: {
      type: Array,
      default: () => ["#ffffff", "#000000"],
    },
    rotateHeaders: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      regionId: null,
      tooltip: {
        show: false,
        left: 0,
        top: 0,
        bottom: 0,
        html: "",
        title: "",
        target: null,
        iso: null,
      },
      orderBy: null,
      orderDir: true,
    };
  },
  computed: {
    interpolator() {
      return interpolateRgb(this.colorScale[0], this.colorScale[1]);
    },
    range() {
      return extent([0, ...this.data.map((row) => max(row.values))]);
    },
    colorScale() {
      return scaleLinear()
        .domain(this.range)
        .range(this.colorRange);
    },
  },
  methods: {
    color(val) {
      if (val === null || isNaN(val)) return colors.gray[50];
      return this.colorScale(val);
    },
    showTooltip({ target }, row, i) {
      this.tooltip.target = target;

      this.tooltip.value = row.values[i];
      this.tooltip.title = row.name;

      this.tooltip.show = true;
    },
    hideTooltip() {
      this.tooltip.show = false;
    },
  },
};
</script>

<style>
@layer components {
  .heat-map-row {
    @apply flex flex-grow font-mono h-full space-x-0 sm:space-x-px;
  }
  .heat-map-square {
    @apply h-full justify-center text-center whitespace-nowrap transition-colors duration-300 cursor-default;
  }
  .heat-map-head-square {
    @apply flex flex-grow items-center px-0 py-0 text-xs whitespace-nowrap font-bold transform overflow-x-visible w-1 justify-center;
  }
  .heat-map-head-square.active {
    @apply text-gray-900;
  }
  .heat-map-head-square.rotate {
    /* @apply rotate-45 -translate-x-1/2 origin-right justify-end; */
    @apply -rotate-45 translate-x-1/2 origin-left justify-start;
  }
}
</style>
¡
